(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .controller('DocumentFileDialogController', DocumentFileDialogController);

    DocumentFileDialogController.$inject = ['$timeout', '$scope',  '$uibModalInstance', 'entity', 'DocumentFile', 'Document'];

    function DocumentFileDialogController ($timeout, $scope,  $uibModalInstance, entity, DocumentFile, Document) {
        var vm = this;

        vm.documentFile = entity;
        vm.clear = clear;
        vm.save = save;
        vm.documents = Document.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (angular.isDefined(vm.documentFile.id ) && vm.documentFile.id !== null) {
                DocumentFile.update(vm.documentFile, onSaveSuccess, onSaveError);
            } else {
                DocumentFile.save(vm.documentFile, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('eDocumentsApp:documentFileUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
